import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Container from "@material-ui/core/Container";
import CustomContainer from "../../components/container/CustomContainer";
import {
  generatePageURI,
  pagePaths,
  customMuiTheme,
  showFooter
} from "../../common/utilities";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import InfoContainer from "../../components/container/InfoContainer";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ThemeProvider } from "@material-ui/styles";

import Hidden from "@material-ui/core/Hidden";
import clsx from "clsx";

import styles from "./SubPageTemplate.module.scss";

function WrappedInfoContainer({ mobile, headingLeft, headingRight, children }) {
  return (
    <InfoContainer
      classes={{
        root: styles.info_root,
        content: styles.content,
        info: styles.info,
        headerLeft: styles.headers,
        headerRight: styles.headers
      }}
      headerLeft={headingLeft}
      headerRight={headingRight}
      mobile={mobile}
    >
      {children}
    </InfoContainer>
  );
}

function SubPageContent({
  mobile,
  headingLeft,
  headingRight,
  backToURL,
  backToText,
  children
}) {
  return (
    <div className={clsx(styles.content_parent, mobile && styles.mobile)}>
      <div
        className={clsx(styles.back_to_pfl_container, mobile && styles.mobile)}
      >
        <Link
          className={clsx(styles.back_to_pfl, mobile && styles.mobile)}
          to={backToURL}
        >
          &lt; {backToText}
        </Link>
      </div>
      <WrappedInfoContainer
        mobile={mobile}
        headingLeft={headingLeft}
        headingRight={headingRight}
        children={children}
      />
    </div>
  );
}

export default function SubPageTemplate(props) {
  const { t, i18n } = useTranslation();

  const {
    title,
    children,
    headerData,
    headingLeft,
    headingRight,
    backToText = t("Back to Profile"),
    backToURL = generatePageURI(pagePaths.MAIN)
  } = props;

  //causes fouc on compoent mount - may want to consider some fix for
  //this
  //e.g. styled compoentns, media query in scss, depends on how bad
  //we think it is
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  // console.log('mobile1', mobile);

  // Similar to componentDidMount:
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (headerData) {
    document.title = title;
    showFooter();
    // document.getElementById("sgw-top-navigation").style.display = "block";
    // document.getElementById("sgw-footer").style.display = "block";
  }

  //using <Hidden /> becuase using mat-ui media queries
  //technique
  //(https://material-ui.com/components/use-media-query/)
  //does fouk on mobile load - you will need to
  //try it here to see

  // const WrappedInfoContainer = ({ mobile }) => (
  //   <InfoContainer
  //     classes={{
  //       root: styles.info_root,
  //       content: styles.info_content,
  //       headerLeft: styles.headers,
  //       headerRight: styles.headers
  //     }}
  //     headerLeft={headingLeft}
  //     headerRight={headingRight}
  //     mobile={mobile}
  //   >
  //     <main className={styles.content}>{children}</main>
  //   </InfoContainer>
  // );

  // const SubPageContent = ({ mobile }) => (
  //   <div className={clsx(
  //       styles.content_parent,
  //       mobile && styles.mobile
  //     )}>
  //     <Link className={
  //       clsx(
  //         styles.back_to_pfl,
  //         mobile && styles.mobile
  //       )}
  //       to={backToURL}
  //     >
  //       &lt; {backToText}
  //     </Link>
  //     <WrappedInfoContainer mobile={mobile} />
  //   </div>
  // );

  return (
    <ThemeProvider theme={customMuiTheme}>
      <Header headerData={headerData} />
      <main className={clsx(
          styles.container
        )}
      >
        <CustomContainer maxWidth="xl" subpage>
          <SubPageContent
            mobile={mobile}
            headingLeft={headingLeft}
            headingRight={headingRight}
            backToURL={backToURL}
            backToText={backToText}
            children={children}
          />
        </CustomContainer>
      </main>
    </ThemeProvider>
  );

  // return (
  //   <Container maxWidth="xl" classes={{ root: styles.container }}>
  //     <Header headerData={headerData} />
  //     <Container maxWidth="lg">
  //       {/* desktop */}
  //       <Hidden xsDown>
  //         <SubPageContent />
  //       </Hidden>
  //       {/* mobile */}
  //       <Hidden smUp>
  //         <SubPageContent mobile />
  //       </Hidden>
  //     </Container>
  //   </Container>
  // );
}
